export default "__VITE_ASSET__389e509c__"